module.exports = __webpack_public_path__ + "img/kid1.e4e05e00.png";